import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

const OrderCompletedPage = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography
        variant='h4'
        sx={{ my: 2 }}>
        交易完成
      </Typography>
      <Box>
        <Typography
          variant='h6'
          sx={{ px: 2, my: 2, textAlign: 'left' }}>
          感謝您投保安達產物行動裝置保險，立格科技為本專案指定維修中心，若有維修需求請送回原門市以確保您的權益。安信保險代理人(股)有限公司也將提供您更多保險資訊及服務，祝您一切順心！
        </Typography>
        <Button
          color='info'
          variant='contained'
          sx={{ width: 168 }}
          onClick={() => {
            navigate('/login');
          }}>
          結束
        </Button>
      </Box>
      ·
    </Box>
  );
};

export default OrderCompletedPage;
